$(function() {

    let $side_panel_name = '#side-panel-modal', $side_panel = $($side_panel_name);
    let sidePanel__formValidation;

    $(window).on('shown.bs.modal', function() {
        $(window).trigger('resize');
    });

    $(window).on('hidden.bs.modal', function() {
        if (sidePanel__formValidation) {
            sidePanel__formValidation.destroy();
        }
        $side_panel.find('.modal-dialog').removeClass('modal-xxl');
        $side_panel.find('.modal-dialog').removeClass('modal-xl');
        $side_panel.find('.modal-body').html('')
    });

    $("body").on('click', '.side-panel-request', function(event){
        event.preventDefault();
        let $request = $(this).data('request');

        let api_token = $('meta[name="api_token"]').attr('content');
        const dialog = $side_panel.find('.modal-dialog');
        dialog.removeClass('modal-xxl');
        dialog.removeClass('modal-xl');
        dialog.removeClass('modal-md');
        const button = $(this);
        let size;
        if (button.hasClass('side-panel-modal-xxl')) {
            size = 'xxl';
            $side_panel.find('.modal-dialog').addClass('modal-xxl');
        }else if (button.hasClass('side-panel-modal-xl')){
            size = 'xl';
            $side_panel.find('.modal-dialog').addClass('modal-xl');
        } else {
            size = 'md';
            $side_panel.find('.modal-dialog').addClass('modal-md');
        }

        if ( $(this).hasClass('side-panel-request-dark') ){
            $side_panel.find('.modal-dialog').addClass('modal-dialog-dark').find('.btn-close').addClass('btn-close-white');
        } else {
            $side_panel.find('.modal-dialog').removeClass('modal-dialog-dark').find('.btn-close').removeClass('btn-close-white');
        }

        $.ajax({
            type: 'GET',
            data: { api_token: api_token },
            url: $request
        }).then(($response) => {
            window.openSidePanel($response, null, size);
        });
    });

    window.openSidePanel = (body, title = null, size= 'md') => {
        if (size) {
            ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach((s) => {
                $side_panel.find('.modal-dialog').removeClass('modal-' + s);
            });
            $side_panel.find('.modal-dialog').addClass('modal-' + size);
        }
        $side_panel.find(".modal-body").html(body);
        if (title) {
            $side_panel.find('.modal-title').text(title);
        } else {
            const titleEl = $side_panel.find('.side-panel-title');
            if (titleEl.length) {
                $side_panel.find('.modal-title').text(titleEl.text());
                titleEl.remove();
            }
        }

        $side_panel.modal('show');
        window.initSelect2(
            {
                width: '100%',
                dropdownParent: $side_panel
            },
            $side_panel.find(".modal-body .select2")
        );
        window.initClockPicker({
            placement: 'top'
        }, $side_panel.find(".modal-body .clockpicker"));

        const form = $side_panel.find(".modal-body").find('form');
        if (form.length) {
            sidePanel__handleSidePanelForm(form);
        }
    }

    window.reloadFormValidator = () => {
        if (sidePanel__formValidation) {
            sidePanel__formValidation.destroy();
            sidePanel__handleSidePanelForm($(sidePanel__formValidation.currentForm))
        }
    }

    function sidePanel__handleSidePanelForm(form) {
        const rules = {};
        const action = form.attr('action');
        const redirect = form.data('redirect');
        const confirmText = form.data('confirm-text');
        $.each(form.find(':input'), function (index, element) {
            const el = $(element);
            if (el.data('rules')) {
                rules[el.attr('name')] = el.data('rules');
            }
        });
        sidePanel__formValidation = form.validate({
            rules: rules,
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('invalid-feedback');
                element.closest('.form-group').append(error);
            },
            highlight: function (element, errorClass, validClass) {
                $(element).addClass('is-invalid');
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass('is-invalid');
            },
            submitHandler: function (form, e) {
                e.preventDefault();
                const data = new FormData(form);
                const _form = $(form);
                $.each(_form.find(':input'), function (index, el) {
                    const element = $(el);
                    if (Array.isArray(element.val())) {
                        element.val().forEach((value, index) => {
                            data.append(`${element.attr('name')}[${index}]`, value)
                        });
                    }
                });
                const button = _form.find('[type="submit"]');
                button.prop('disabled', true);
                $.ajax({
                    type: 'POST',
                    url: action,
                    data: data,
                    processData: false,
                    contentType: false
                }).then(function (response) {
                    button.prop('disabled', false);
                    if (confirmText) {
                        if (redirect) {
                            Swal.fire(confirmText, '', 'success').then(() => {
                                redirectOperations(redirect);
                            });
                        } else {
                            Swal.fire(confirmText, '', 'success');
                            triggerOperations(_form, response);
                        }
                    } else {
                        if (redirect) {
                            redirectOperations(redirect);
                        } else {
                            triggerOperations(_form, response);
                        }
                    }
                    $side_panel.modal('hide');
                }).catch(function (error) {
                    button.prop('disabled', false);
                    if (error.status === 422) {
                        const errors = error.responseJSON.errors;
                        for (const error in errors) {
                            if (error.includes('.')) {
                                let errorKey = error;
                                let firstDot = true;
                                while (errorKey.includes('.')) {
                                    if (firstDot) {
                                        errorKey = errorKey.replace('.', '[');
                                        firstDot = false;
                                    } else {
                                        errorKey = errorKey.replace('.', '][');
                                    }
                                }
                                errorKey += ']';
                                errors[errorKey] = errors[error];
                                delete errors[error];
                            }
                        }
                        window.openErroredCollapsiblePanels(errors);
                        sidePanel__formValidation.showErrors(errors);
                        Swal.fire($('meta[name="lang_error_validation_message"]').attr('content'), '', 'error')
                    } else {
                        Swal.fire(error.statusText, '', 'error')
                    }
                    _form.trigger('error-response', error);
                });
            }
        });
    }

    function redirectOperations (url) {
        window.location.href = url;
    }
    function triggerOperations (el, response) {
        el.trigger('success-response', response)
        let datatables = []
        if (typeof dataTable !== 'undefined' && dataTable) {
            datatables.push(dataTable)
        }
        if (typeof dataTables === 'object') {
            for (const dt in dataTables) {
                datatables.push(dataTables[dt])
            }
        }
        for (const dt of datatables) {
            const settingsOnDraw = dt.settingsOnDraw || {}
            if (settingsOnDraw.order) {
                dt.order(settingsOnDraw.order)
            }
            if (settingsOnDraw.notDrawOnPage) {
                dt.draw();
            } else {
                dt.draw('page');
            }
        }
    }

    $(document).on('click', '.btn-confirm-action-request', async function (e) {
        e.preventDefault();
        const _this = $(this);
        const url = _this.data('url');
        const type = _this.data('method');
        const data = _this.data('data');
        const title = _this.data('title');
        const confirmText = _this.data('confirm-text');
        const redirect = _this.data('redirect');
        const infoUrl = _this.data('info-url');
        let info;
        if (infoUrl) {
            info = await $.ajax(infoUrl)
        }
        const options = {
            title: title,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }
        if (info) {
            options.html = info.message;
        }
        Swal.fire(options).then((result) => {
            if (result.isConfirmed) {
                $.ajax({ url, type, data }).then((response) => {
                    if (confirmText) {
                        if (redirect) {
                            Swal.fire(confirmText, '', 'success').then(() => {
                                redirectOperations(redirect);
                            });
                        } else {
                            Swal.fire(confirmText, '', 'success');
                            triggerOperations(_this, response);
                        }
                        return;
                    }
                    if (redirect) {
                        redirectOperations(redirect);
                    } else {
                        triggerOperations(_this, response);
                    }

                }).catch((error) => {
                    Swal.fire(error.statusText, '', 'error')
                    _this.trigger('error-response', error)
                });
            }
        });
    });

    $("body").on('click', '.side-panel-modal', function(event){
        event.preventDefault();
        const button = $(this);
        let $modal_id = button.data('modal-target');
        let $modal_content = $( $modal_id ).find('>div').clone();
        const dialog = $side_panel.find('.modal-dialog');
        dialog.removeClass('modal-xxl');
        dialog.removeClass('modal-xl');
        dialog.removeClass('modal-md');
        if (button.hasClass('side-panel-modal-xxl')) {
            dialog.addClass('modal-xxl');
        } else if (button.hasClass('side-panel-modal-xl')) {
            dialog.addClass('modal-xl');
        } else {
            dialog.addClass('modal-md');
        }

        if ( $(this).hasClass('side-panel-modal-dark') ){
            dialog.addClass('modal-dialog-dark')
                .find('.btn-close').addClass('btn-close-white');
        } else {
            dialog.removeClass('modal-dialog-dark')
                .find('.btn-close').removeClass('btn-close-white');
        }

        $side_panel.find(".modal-body").html( $modal_content );
        $side_panel.modal('show');
    });
});
